import {Model} from '@/models/Model'
import {Product} from '@/models/Product'
import {DataArray, DataResource} from '@/models/Response'
import Helper from '../services/Helper.js'


export const ProductPromotionConst = Object.freeze({
  TYPE_TEST: 20,

  map(status: number): string {
    switch (status) {
      case ProductPromotionConst.TYPE_TEST:
        return 'Test'
    }
    return ''
  },
})


export class ProductPromotion extends Model {
  declare id: number | null
  created_at: Date | null
  updated_at: Date | null
  product_id: number
  campaign_id: number | null
  promotion_id: number | null

  index_no: number
  display_index: number

  init_price: number
  display_price: number
  quantity: number
  product: Product | null

  promotion_type: string

  is_child:boolean = false
  children:ProductPromotion[] = []

  getResourceURL(): string {
    return Helper.setting.product_promotion.getResourceAPI
  }


}

export class DataProductPromotionsArray extends DataArray {

  declare data: ProductPromotion[]
  filter: FilterProductPromotion = new FilterProductPromotion()
}


export class FilterProductPromotion {

}


export class DataProductPromotion extends DataResource {

  declare data: ProductPromotion

}
